import React from "react";

// Simple reusable wrapper for rendering trusted HTML with consistent styles
export default function HtmlContent({ html, className = "", emptyContent = "" }) {
  if (!html) return <p className="text-2xs text-zinc-800">{emptyContent}</p>;
  return (
    <div
      className={
        "text-2xs text-zinc-800 [&_[data-list='bullet']]:list-disc [&_[data-list='bullet']]:mt-2 [&_[data-list='bullet']]:ml-3 [&_[data-list='ordered']]:list-decimal [&_[data-list='ordered']]:mt-2 [&_[data-list='ordered']]:ml-3 " +
        className
      }
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
